"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStripeNativeOptions = exports.StripeNativeOptionsProvider = void 0;
const React = require("react");
const react_1 = require("react");
const NativeLinkProvider_1 = require("../../../../../contexts/NativeLinkContext/NativeLinkProvider");
const StripePromiseProvider_1 = require("../StripePromiseProvider");
const StripeNativeOptionsContext = (0, react_1.createContext)({
    Connected: false,
    ActiveMethods: [],
    ShowNativePayment: async () => {
        return null;
    },
    ShowNativeCardEntry: async () => {
        return null;
    }
});
const StripeNativeOptionsProvider = ({ children }) => {
    const stripeContext = (0, StripePromiseProvider_1.useStripePromise)();
    const { nativeClient } = (0, NativeLinkProvider_1.useNativeLink)();
    const [activeMethods, setActiveMethods] = (0, react_1.useState)();
    const [connected, setConnected] = (0, react_1.useState)(false);
    env;
    //when we first mount we should query which methods are supported
    const setupNativeClient = async () => {
        var _a, _b;
        let setupEvent = {
            EventTopic: "SetupNativeStripeClient",
            PublishableKey: env.stripePublishableKey,
            MerchantId: env.stripeMerchantId,
            StoreStripeId: stripeContext.StripeStoreAccountId,
            DialogTimeout: 120000,
            TestEnvironment: (_a = env.stripeTestEnv == true) !== null && _a !== void 0 ? _a : false
        };
        const result = await nativeClient.SubmitEventWithResponse(setupEvent, 2000);
        if (result.Success) {
            setActiveMethods((_b = result.SupportedMethods) !== null && _b !== void 0 ? _b : []);
            setConnected(true);
        }
    };
    const showNativePayment = async (totalCents) => {
        let paymentEvent = {
            EventTopic: "ShowNativePayment",
            TotalCents: totalCents
        };
        const result = await nativeClient.SubmitEventWithResponse(paymentEvent, 125000);
        return result;
    };
    const showNativeCardEntry = async (clientSecret) => {
        let cardEntryEvent = {
            EventTopic: "ShowNativeCardEntry",
            ClientSecret: clientSecret
        };
        const result = await nativeClient.SubmitEventWithResponse(cardEntryEvent, 125000);
        return result;
    };
    (0, react_1.useEffect)(() => {
        if (nativeClient) {
            setupNativeClient();
        }
    }, []);
    let myContext = {
        Connected: connected,
        ActiveMethods: activeMethods,
        ShowNativePayment: showNativePayment,
        ShowNativeCardEntry: showNativeCardEntry
    };
    return (React.createElement(StripeNativeOptionsContext.Provider, { value: myContext }, children));
};
exports.StripeNativeOptionsProvider = StripeNativeOptionsProvider;
// Custom hook to use the context
const useStripeNativeOptions = () => {
    const context = (0, react_1.useContext)(StripeNativeOptionsContext);
    if (context === undefined) {
        throw new Error("useStripeNativeOptions must be used within a StripeNativeOptionsProvider");
    }
    return context;
};
exports.useStripeNativeOptions = useStripeNativeOptions;
//# sourceMappingURL=StripePaymentNativeOptions.js.map